import { render } from "./Anchor.vue?vue&type=template&id=4b13db91"
import script from "./Anchor.vue?vue&type=script&lang=js"
export * from "./Anchor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__